import { useState } from 'react';

import { PriceCard } from '../components';
import { MinusCircle, PlusCircle, Star } from '../icons';

import { faq, plans } from '../copies';

const Pricing = () => {
  const [selectedQ, setSelectedQ] = useState(-1);

  return (
    <>
      {/* Hero section */}
      <section
        id="pricing"
        className="py-24 container max-w-screen-xl mx-auto space-y-24"
      >
        <div className="text-center">
          <p className="text-primary-600 text-lg font-semibold tracking-wide uppercase">
            Get started now
          </p>
          <h2 className="font-extrabold text-4xl sm:text-5xl mt-2">
            Simple and transparent pricing
          </h2>
          <p className="text-2xl text-center max-w-3xl mx-auto text-gray-500 mt-6">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Incidunt
            optio officiis dolore earum error eaque perferendis laudantium sed.
          </p>
        </div>

        <div className="space-y-16 lg:space-y-0 lg:grid lg:grid-cols-3">
          {plans.map(plan => (
            <div
              key={plan.name}
              className={`${
                plan.featured
                  ? 'order-1 lg:order-none  lg:transform lg:scale-110 lg:z-10'
                  : null
              } w-full max-w-lg mx-auto`}
            >
              <PriceCard {...plan} />
            </div>
          ))}
        </div>

        <div className="bg-yellow-50 rounded-lg border border-yellow-200 py-4 lg:py-8 px-4 md:px-12 w-full max-w-lg lg:max-w-max mx-auto text-center md:text-left flex flex-col md:flex-row items-center justify-center md:space-x-4 space-y-4 md:space-y-0 lg:space-x-8">
          <div>
            <p className="tracking-wide uppercase font-bold text-gray-700 text-lg lg:text-xl">
              4.9 Overall rating
            </p>
            <p className="text-base lg:text-lg text-gray-600">
              Serving 2500 companies worldwide
            </p>
          </div>
          <div className="text-yellow-400 flex space-x-1">
            {[...new Array(5)].map((_, i) => (
              <Star className="w-7 h-7" key={i} />
            ))}
          </div>
        </div>
      </section>

      {/* FAQ section */}
      <section className="py-24 container max-w-screen-xl mx-auto space-y-24">
        <div className="text-center">
          <p className="text-primary-600 text-lg font-semibold tracking-wide uppercase">
            Ask us anything
          </p>
          <h2 className="font-extrabold text-4xl sm:text-5xl mt-2">
            Frequently Asked Questions
          </h2>
          <p className="text-2xl text-center max-w-3xl mx-auto text-gray-500 mt-6">
            Lorem, ipsum dolor sit amet consectetur adipisicing elit. Incidunt
            optio officiis dolore earum error eaque perferendis laudantium sed.
          </p>
        </div>

        <div>
          <ul className="divide-y divide-gray-300 md:text-lg">
            {faq.map(({ question, answer }, index) => (
              <li key={index}>
                {/* Question */}
                <button
                  className="py-4 font-bold focus:outline-none hover:text-primary-700 w-full text-left flex items-center justify-between transition-colors space-x-4"
                  onClick={() =>
                    index === selectedQ ? setSelectedQ(-1) : setSelectedQ(index)
                  }
                >
                  <span>{question}</span>
                  {index === selectedQ ? (
                    <MinusCircle className="flex-shrink-0 w-6 h-6 text-primary-600" />
                  ) : (
                    <PlusCircle className="flex-shrink-0 w-6 h-6 text-primary-600" />
                  )}
                </button>

                {/* Answer */}
                {index === selectedQ ? (
                  <div className="pr-6 pb-4 text-gray-500">
                    <p>{answer}</p>
                  </div>
                ) : null}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </>
  );
};
export default Pricing;
